import React, { useState } from "react";
import { asyncActionError } from "../../async/asyncReducer";
import { useDispatch } from "react-redux";
import { Button } from "semantic-ui-react";
import { updateDocument } from "../../firestore/firestoreService";
import { toast } from "react-toastify";

export const SINGLE_INPUT_STRING_TYPE = "string";
export const SINGLE_INPUT_NUMBER_TYPE = "number";

export default function MySingleFieldInput({
  fieldValue = "",
  label,
  placeholder,
  maxLength,
  dbCollection,
  id,
  field,
  type = SINGLE_INPUT_STRING_TYPE,
  ...props
}) {
  const dispatch = useDispatch();

  const [isUpdating, setIsUpdating] = useState(false);
  const [value, setValue] = useState(fieldValue);

  async function handleUpdate() {
    if (type === SINGLE_INPUT_STRING_TYPE && typeof value !== "string") {
      toast.error("type error, expected: string");
      return;
    } else if (type === SINGLE_INPUT_NUMBER_TYPE && isNaN(value)) {
      toast.error("type error, expected: number");
      return;
    }

    try {
      setIsUpdating(true);
      await updateDocument({
        dbCollection,
        id,
        data: {
          [field]: type === SINGLE_INPUT_NUMBER_TYPE ? Number(value) : value,
        },
      });
    } catch (e) {
      dispatch(asyncActionError(e));
    } finally {
      setIsUpdating(false);
    }
  }

  return (
    <div>
      <label>{label}</label>
      <input
        value={value}
        {...props}
        maxLength={maxLength}
        placeholder={placeholder}
        onChange={(e) => setValue(e.target.value)}
      />
      <Button
        className="overwrite-button cta-orange block-button"
        content={"Update"}
        onClick={handleUpdate}
        loading={isUpdating}
        style={{ margin: "15px 0 0 2px" }}
        type={"button"}
      />
    </div>
  );
}
